import React, { useState } from 'react';
import { Button, Stack, TextField } from '@mui/material';
import AxiosRequest from 'api/AxiosRequest';
import ErrorAlert from 'components/common/ErrorAlert';
import SuccessAlert from 'components/common/SuccessAlert';
import Cookies from 'js-cookie';

const VerifyNumberSubmit = ({ closeDialog, userData, updateUserData }) => {
    const [newPin, setNewPin] = useState(null);
    const [confirmPin, setConfirmPin] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorCode, setErrorCode] = useState(null);

    const AddVerifiedNumber = (e) => {
        e.preventDefault();
        const data = {
            "new_password": newPin
        };

        if (confirmPin != newPin) {
            return setErrorMessage('New security PIN confirmation does not match.');
        }

        AxiosRequest("Account/" + userData.sid + "/password", data).then(() => {
            setSuccessMessage("Your account number has been successfully verified!");
            setErrorMessage(null);
            setErrorCode(null);
            setTimeout(() => {
                Cookies.set("login_type", "phone", {
                    expires: 7,
                });
                closeDialog();
                setErrorCode(null);
                setErrorMessage(null);
                setSuccessMessage(null);
                updateUserData();
            }, 3000);
        })
        .catch(error => {
            console.log(error);
            if (error && error.response) {
                if (error.response.status && error.response.status >= 500) {
                    setErrorMessage("There was an error. Please try again.");        
                } else if (error.response.data.error) {
                    setErrorMessage(error.response.data.error.message);
                    setErrorCode(error.response.data.error.code);
                } else {
                    setErrorMessage("There was an error. Please try again.");
                }
            }
        });
    }

    return (
        <section className={"callback-section step-section"}>
            <h2>Set your PIN</h2>
            <p>Choose a 4-digit PIN you will use to log in.</p>
            <form onSubmit={AddVerifiedNumber}>
                <Stack direction="column" spacing={ 2 }>
                    <TextField label="Enter a 4-digit PIN"  variant="outlined" size="medium" type='password'
                        onChange={e => setNewPin(e.target.value)} 
                    />
                    <TextField label="Confirm your 4-digit PIN"  variant="outlined" size="medium" type='password'
                        onChange={e => setConfirmPin(e.target.value)} 
                    />
                    {successMessage &&
                    <SuccessAlert message={successMessage} />
                    }
                    {errorMessage &&
                    <ErrorAlert message={errorMessage} code={errorCode} />
                    }
                    <Button variant="contained" size="large" type="submit" className='login-submit'>
                        Create PIN
                    </Button>
                </Stack>
            </form>
        </section>
    );
};

export default VerifyNumberSubmit;
